import { ContactCompanyEntity, ContactEntity, ContactIndividualEntity } from '@app/client';
import { ContactEnum } from '../enums/contact-enum';

export function isIndividual(contact?: ContactEntity): contact is ContactIndividualEntity {
  return contact?.type === ContactEnum.INDIVIDUAL;
}

export function isCompany(contact?: ContactEntity): contact is ContactCompanyEntity {
  return contact?.type === ContactEnum.COMPANY;
}

export function getNominative(contact?: ContactEntity) {
  if (isIndividual(contact)) {
    return `${contact.firstName || ''} ${contact.lastName || ''}`;
  } else if (isCompany(contact)) {
    return `${contact.businessName || ''}`;
  }

  return '';
}
